// extracted by mini-css-extract-plugin
export default {"card":"cardValores_card__QyyMC","imgContainer":"cardValores_imgContainer__dmZqc","card_text":"cardValores_card_text__OvG-U","description":"cardValores_description__zBapT"};